import React from "react";

const ApdexHelp = () => {
  return (
    <div className="help-center">
      <p>
        Apdex is a client perception based performance metric. It buckets
        requests in 3 categories depending on their response time: Satisfied,
        Tolerating and Frustrated. It then computes a single number between 0
        and 1 (higher the better) using the formula shown below. Computing the
        Apdex requires a single parameter T "threshold" used to draw the line
        (in term of response time) between the 3 buckets: all requests faster
        than T are Satisfied, all requests between T and T*4 are Tolerating and
        all other requests (above T*4 or failed) are considered Frustrated.
      </p>
      <img
        src="https://i.embed.ly/1/image?url=https%3A%2F%2Fupdown.io%2Ffaq%2Fapdex%2Fapdex.svg&key=16b1a988066d11e191834040d3dc5c07"
        alt="apdex"
      />
      <p>
        Apdex is usually applied server-side, measuring app response time only,
        but it is totally possible to compute it client-side like updown.io
        does. In this case it also includes network latency, which is a good
        thing because your users too, but it requires higher thresholds to take
        this into account.
      </p>
      <br />

      <p>
        We recommend setting the Apdex T just above your usual response times,
        for example in this case 0.5 would be a good value:
      </p>
      <img
        src="https://i.embed.ly/1/image?url=https%3A%2F%2Fupdown.io%2Ffaq%2Fapdex%2Fdistribution.png&key=16b1a988066d11e191834040d3dc5c07"
        alt="apdex-chart"
      />
      <a
        href="https://updown.uservoice.com/knowledgebase/articles/915588"
        target="blank"
      >
        source
      </a>
    </div>
  );
};

export default ApdexHelp;
